import { fetchResponse, requireStatus } from "./http";

export async function submitAccountEmailRequest(
  apiOrigin: string,
  path: string,
  body: Readonly<Record<string, string>>,
  expectedStatus: number,
): Promise<void> {
  const response = await fetchResponse(`${apiOrigin}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    credentials: "omit",
    referrerPolicy: "no-referrer",
  });
  await requireStatus(response, expectedStatus);
}
